export const discoverTranslations = {
  en: {
    header: "How can Innaxys help your organisation?",
    subheading: "Our sales team can walk you through anything you need to know",
    ctaButton: "Contact us"
  },
  fr: {
    header: "Comment Innaxys peut-elle aider votre organisation ?",
    subheading: "Notre équipe commerciale peut vous guider à travers tout ce que vous devez savoir",
    ctaButton: "Contactez-nous"
  },
  de: {
    header: "Wie kann Innaxys Ihrer Organisation helfen?",
    subheading: "Unser Vertriebsteam hilft Ihnen gerne bei allen Fragen weiter",
    ctaButton: "Kontaktieren Sie uns"
  },
  es: {
    header: "¿Cómo puede ayudar Innaxys a su organización?",
    subheading: "Nuestro equipo de ventas puede guiarle en todo lo que necesite saber",
    ctaButton: "Contáctenos"
  }
};
